import type { SearchParameters } from 'lib-search-types';
import { convertFiltersObjectToString } from 'lib-search-ui';

import { AppPathConfig } from 'utils/url/appPaths';
import { createAppUrl } from 'utils/url/createAppUrl';

import { convertSortObjectToString } from '../sort/convertSort';

/**
 * Creates a Search URL params object that can be passed to `AppLink`.
 *
 * @param params The current Search parameters
 */
export function createSearchUrlParams(
  params: Omit<SearchParameters<'conversations'>, 'scope'>,
): AppPathConfig['/search/conversations'] {
  const { query, filters, isStrict, page, sortBy } = params;

  return {
    search: {
      q: query || undefined,
      filters: convertFiltersObjectToString(filters) || undefined,
      sort: convertSortObjectToString(sortBy) || undefined,
      strict: isStrict ? 'true' : undefined,
      page: page && page > 1 ? page.toString() : undefined,
    },
  };
}

/**
 * Creates a Search URL with supported path and query parameters.
 *
 * @param params The current Search parameters
 */
export function createSearchUrl(
  params: Omit<SearchParameters<'conversations'>, 'scope'>,
): string {
  const url = createAppUrl({
    path: '/search/conversations',
    params: createSearchUrlParams(params),
  });

  return url;
}
